import { __assign, __rest } from "tslib";
import React from 'react';
import VeltNotificationsToolIconWireframe from './VeltNotificationsToolIconWireframe/VeltNotificationsToolIconWireframe';
import VeltNotificationsToolLabelWireframe from './VeltNotificationsToolLabelWireframe/VeltNotificationsToolLabelWireframe';
import VeltNotificationsToolUnreadCountWireframe from './VeltNotificationsToolUnreadCountWireframe/VeltNotificationsToolUnreadCountWireframe';
import VeltNotificationsToolUnreadIconWireframe from './VeltNotificationsToolUnreadIconWireframe/VeltNotificationsToolUnreadIconWireframe';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltNotificationsToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-tool-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsToolWireframe.Label = VeltNotificationsToolLabelWireframe;
VeltNotificationsToolWireframe.UnreadIcon = VeltNotificationsToolUnreadIconWireframe;
VeltNotificationsToolWireframe.Icon = VeltNotificationsToolIconWireframe;
VeltNotificationsToolWireframe.UnreadCount = VeltNotificationsToolUnreadCountWireframe;
export default VeltNotificationsToolWireframe;
